(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DBProfileManagementController', DBProfileManagementController);

    DBProfileManagementController.$inject = ['Principal', 'History', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'ObjectDiff'];

    function DBProfileManagementController(Principal, History, AlertService, $state, pagingParams, paginationConstants, ObjectDiff) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.profiles = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();


        function loadAll () {
            History.profileAdd({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {

            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.profiles = data;
            vm.profiles = vm.profiles.map(function (profile) {

                if (isNaN(profile.importId)) {
                    profile.importSource = profile.importId;
                } else {

                    profile.importSource =  profile.domain;
                }
                if (profile.revisionType == 'MOD'){
                    History.previousProfile({profileId : profile.id}, function(previousProfile){
                        if (previousProfile){

                            previousProfile.lastModifiedDate = null;
                            delete previousProfile.$promise;
                            delete previousProfile.$resolved;
                            // you can directly diff your objects js now or parse a Json to object and diff
                            var diff = ObjectDiff.diff(previousProfile, profile);

                            delete diff.value.revisionDate;

                            delete diff.value.lastModifiedDate;
                            delete diff.value.lastModifiedBy;
                            delete diff.value.revisionType;
                            delete diff.value.revisionId;
                            delete diff.value.importSource;
                            delete diff.value.originalImport;
                            var diffValue = ObjectDiff.toJsonDiffView(diff);


                            profile.diffValue = diffValue;
                        }
                    });
                }

                return profile;
            });

        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
